<template>
 <div class="detail-content">
    <div class="basic-info">
      <a-table
        :columns="columns"
        row-key="temperatureLayerCode"
        :data-source="chargeInfos"
        :pagination="false"
      >
      <span slot="temperatureRrice" slot-scope="text, record" class="tempera-price">
        {{record.price}}{{record.unit || '元/托/天'}}
      </span>
      </a-table>
    </div>
  </div>
</template>

<script>

  export default {
    name:'WarehouseInfoTable',
    components:{
    },
    props:{
      title:{
        type:String,
        default:''
      },
      columns:{
        type:Array,
        default:()=>[]
      },
      chargeInfos:{
         type:Array,
        default:()=>[]
      },
    },
    methods:{
    }
  }
</script>

<style lang="less" scoped>
.detail-content {
    .introduce {
      margin: 16px 32px 23px 32px;
      font-size: 14px;
    }
    .introduce-less {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .basic-info {
      padding:0px 0px 23px;
      // margin: 0px 32px;
      .detail-list {
        display: -webkit-box;
        line-height: 54px;
        border-bottom: 1px solid #f5f6f7;
        box-sizing: border-box;
        .dt-list-title {
          display: inline-block;
          width: 100px;
          color: #606266;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          background-position: 0px 16px;
          padding-left: 28px;
          margin-right: 80px;
        }
        // .wuqu {
        //   background-image: url('../../assets/img/detail/icon-detail-wenqu.png');
        // }
        .area {
          background-image: url('../../../assets/img/detail/icon-detail-area.png');
        }
        .type {
          background-image: url('../../../assets/img/detail/icon-detail-house.png');
        }
        .facilitie {
          background-image: url('../../../assets/img/detail/icon_facilities.png');
        }
        .equipment {
          background-image: url('../../../assets/img/detail/icon_equipment.png');
        }
        .recommend {
          background-image: url('../../../assets/img/detail/icon_service.png');
        }
        .fire-control {
          background-image: url('../../../assets/img/detail/icon_fire_control.png');
        }
        .aptitude {
          background-image: url('../../../assets/img/detail/icon-detail-zizhi.png');
        }
        .feature {
          background-image: url('../../../assets/img/detail/icon-detail-label.png');
        }
        .time {
          background-image: url('../../../assets/img/detail/icon-detail-time.png');
        }

        // .dt-list-content {
        //   display: inline-block;
        // }
      }
      .tempera-price {
        color: #ED4934;
      }
    }
  }
  .pre-title {
    font-size: 18px;
    color: #171717;
    font-weight: bold;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 4px;
      height: 16px;
      display: block;
      background: #06b880;
      border-radius: 2px;
      margin-right: 28px;
    }
  }
</style>